import { merge } from 'lodash';

/**
 * @description
 * This plugin is used to override the static config values with the runtimeConfig values.
 * This is necessary because the static config values are not available at runtime.
 * The runtimeConfig values are available on both client and server side, so we can use them to override the static config values.
 * This is useful for example when we want to use different API URLs for development and production environments.
 */
export default function ({ $auth, $config }) {
  if ($auth && $config) {
    $auth.options = merge($auth.options, {
      redirect: {
        logout: '/login'
      }
    });
    $auth.strategies.local.options = merge($auth.strategies.local.options, {
      token: {
        maxAge: $config.TOKEN_MAX_AGE
      },
      endpoints: {
        login: {
          url: $config.LOGIN_URL,
          method: 'post',
          propertyName: 'token'
        }
      }
    });
  }
}
